// extracted by mini-css-extract-plugin
export var changeIcon = "_4y-4";
export var clickable = "_4y-8";
export var container = "_4y-0";
export var divider = "_4y-7";
export var externalLinkIcon = "_4y-1";
export var green = "_4y-5";
export var helpCircleIcon = "_4y-3";
export var iconButton = "_4y-2";
export var red = "_4y-6";